import { Color } from './color';
/**
 * ◇
 */
export const HollowDiamond = (options) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'diamond' }, options));
};
HollowDiamond.props = Object.assign({}, Color.props);
//# sourceMappingURL=hollowDiamond.js.map